var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.495 11.267c-1.4-6.16-6.7734-8.9333-11.493-8.9333h-0.0133c-4.7067 0-10.093 2.76-11.493 8.92-1.56 6.88 2.6533 12.707 6.4667 16.373 1.4133 1.36 3.2267 2.04 5.04 2.04 1.8134 0 3.6267-0.68 5.0267-2.04 3.8133-3.6667 8.0267-9.48 6.4667-16.36zm-11.493 6.68c-2.32 0-4.2-1.88-4.2-4.2s1.88-4.2 4.2-4.2 4.2001 1.88 4.2001 4.2-1.8801 4.2-4.2001 4.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.7f738293b0c5bdf22c79886cf5575892.svg";
export { ForwardRef as ReactComponent };